'use client';

import { Fragment } from 'react';
import { Badge } from '@/components/ui/badge';
import { getContactDisplayName } from '@/lib/services/contacts/utils';
import { FormField } from '../FormField';
import {
  VEHICLE_INSTRUCTION_LABELS,
  type VehicleInstructionSectionProps
} from './constants';

type VehicleInstructionReadSectionProps = Pick<
  VehicleInstructionSectionProps,
  | 'instruction'
  | 'milestoneSummary'
  | 'transferBeneficiaries'
  | 'hasContraryIntention'
  | 'contacts'
>;

export function VehicleInstructionReadSection({
  instruction,
  milestoneSummary,
  transferBeneficiaries,
  hasContraryIntention,
  contacts
}: VehicleInstructionReadSectionProps) {
  const resolveName = (b: {
    contactId: number;
    contact?: {
      firstName: string;
      lastName: string;
      organisationName?: string | null;
    };
  }): string => {
    if (b.contact) {
      return getContactDisplayName(b.contact);
    }
    const match = contacts?.find((c) => c.id === b.contactId);
    return match ? getContactDisplayName(match) : '';
  };
  return (
    <Fragment>
      <div className="border-border-subtle w-full border-t" />
      <div className="flex w-full flex-col gap-2">
        <FormField
          label="Instruction"
          value={
            instruction && instruction !== 'undecided'
              ? VEHICLE_INSTRUCTION_LABELS[instruction]
              : '—'
          }
          mode="read"
        />
        {!!transferBeneficiaries &&
          transferBeneficiaries.length > 0 &&
          instruction === 'transfer-to-beneficiary' && (
            <FormField
              label="Transferring to"
              value={transferBeneficiaries
                .map(resolveName)
                .filter(Boolean)
                .join(', ')}
              mode="read"
            />
          )}
        {instruction === 'transfer-to-beneficiary' &&
          !!hasContraryIntention && (
            <FormField
              label="Contrary Intention"
              value="Estate pays off loan"
              mode="read"
            />
          )}
        {!!milestoneSummary && (
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground text-sm">Milestones</span>
            <Badge variant="outline" className="">
              {milestoneSummary}
            </Badge>
          </div>
        )}
      </div>
    </Fragment>
  );
}
